export const UnsplashSourceName = 'unsplash';